export default __webpack_public_path__ + "static/media/Bloomberg.3b39fd1a.svg";